<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información de la Instrucción de Cobro"
          :datos="instruccionCobroDatos">
        </app-data>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Comprobantes" v-if="instruccionCobroComprobantes.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="instruccionCobroComprobantes" 
              :fields="comprobantesFields">
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(importeInstruccionCobro)="data">
              {{ data.item.importeInstruccionCobro | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
        <!-- <b-card header="Cheques" v-if="cobroChequesTerceros.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="cobroChequesTerceros" 
              :fields="chequesTercerosFields">
            <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
            </template>
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(numero)="data">
              <template v-if="!data.item.sinNumero" >
                {{ data.item.numero }}
              </template>
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card> -->
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'instruccionCobro/getField',
  mutationType: 'instruccionCobro/updateField',
});

export default {
  name: 'InstruccionCobroData',
  components: {
    appData: Data,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data: () => {
    return {
      instruccionCobroId: 0,

      comprobantesFields: [
        { 
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { key: 'fechaVencimiento' },
        { 
          key: 'comprobanteTipo',
          label: 'Comprobante'
        },
        { 
          key: 'comprobanteNumero',
          label: 'Nro.Comprobante'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'importeInstruccionCobro',
          label: 'Importe Instrucción',
          class: 'text-right'
        },
      ],
    }
  },
  created() {
    this.instruccionCobroId = this.$route.params.id;

    this.$store.dispatch('instruccionCobro/getDatos', this.instruccionCobroId)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'instruccionCobroDatos',
      'instruccionCobroComprobantes',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
